import { PageState } from 'models/PageState';
import { isProductPage } from 'models/ProductPageModel';
import { PackageProduct } from 'models/PackageProduct';

export const getPackage = ({ currentPage }: PageState) =>
  isProductPage(currentPage) ? currentPage.packageProduct : undefined;

export const showPackageAndSavings = (
  packageProduct?: PackageProduct
): { show: boolean; savings: number } => {
  if (
    packageProduct === undefined ||
    packageProduct.products === undefined ||
    packageProduct.products.every(p => p.title === undefined)
  ) {
    return { show: false, savings: 0 };
  }

  const { products, price, limitAmount, limitPercentage } = packageProduct;

  const packageSeparatePrice = products.reduce(
    (total, product) => total + product.price.listPrice * product.quantity.amount,
    0
  );
  const savingsAmount = packageSeparatePrice - price.listPrice;
  const savingsPercentage = savingsAmount / price.listPrice;

  const savingsInLimits =
    savingsAmount > 0 && savingsAmount > limitAmount && savingsPercentage > limitPercentage;

  if (!savingsInLimits) {
    return { show: false, savings: 0 };
  }

  const averageListPrice =
    savingsAmount / products.reduce((total, product) => total + product.quantity.amount, 0);

  const averageListPricePercentage = 0.7;
  const averageListPriceLimit = averageListPrice * averageListPricePercentage;
  const aboveAverageListPriceLimit = price.listPrice > averageListPriceLimit;

  return aboveAverageListPriceLimit
    ? { show: true, savings: savingsAmount }
    : { show: false, savings: 0 };
};
